module.exports = __webpack_public_path__ + "88a91fabd7a84725ba47fb8a8aabf313.svg";